var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image_box"},[_c('img',{staticStyle:{"max-width":"100%","max-height":"400rpx","margin":"0 auto"},attrs:{"src":_vm.url},on:{"click":_vm.imgClick}})])}
var staticRenderFns = []

export { render, staticRenderFns }